/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React, { useEffect } from "react";
import { Navbar } from "../../components/navbar/navbar";
import { Outlet } from "react-router-dom";
import "./home.scss";
import {
  PermissionForRoles,
  RolePersmission,
} from "../../context/RolePermissionContext";
import { CircularProgress } from "@mui/material";
import { TimerValusSet } from "../../context/TimerContext";
import SessionTimer from "../../components/sessionExpirePopup/sessionTimer";

export const HomePage: React.FC<any> = () => {
  const { loadingStatus } = React.useContext(RolePersmission);
  const {
    setUserHeartBeat,
    timeExit, setShowConfirmation
  } = React.useContext(TimerValusSet);

  window.onfocus = function () {
    const timerValue = timeExit();

    if (timerValue < 300) {
      setUserHeartBeat(timerValue);
      setShowConfirmation(true);
    } else {
      setShowConfirmation(false);
      setUserHeartBeat(timerValue);
    }
  };

  useEffect(() => {
    setUserHeartBeat(timeExit());
  }, []);

  return (
    <div className="homeWrapper">
      <PermissionForRoles>
        {loadingStatus && (
          <div className="loadingStatus">
            <CircularProgress size={40} />
          </div>
        )}
        <div className="home">
          <Navbar />
          <div className="homeContainer">
            <div className="outletWrapper">
              <Outlet />
            </div>
          </div>
        </div>
        <SessionTimer />
      </PermissionForRoles>
    </div>
  );
};
